
import Vue from "vue";
import { AuthService } from "../../services/auth-service";
import { BookYearService } from "../../services/book-year-service";
import AppSettingsFriendlyIds from "../settings-default/FriendlyIds.vue";
export default Vue.extend({
	data() {
		return {
			step: 0,
			copySales: false,
			copyPurchases: false,
			copyStock: false,
			copyBackorderSales: false,
			copyBankSaldos: false
		};
	},
	computed: {
		toCreateYear():number {
			return BookYearService.newestBookYear.Year + 1;
		},
		isManual():boolean{
			return BookYearService.manualCreateNewBookyear;
		}
	},
	methods: {
		logout() {
			AuthService.logout();
		},
		close(){
			this.$emit("close");
		},
		async createNewBookYear() {
			this.step = 2;
			try{
				let createdBookYear = await BookYearService.postBookYear(this.copySales, this.copyPurchases, this.copyStock, this.copyBackorderSales, this.copyBankSaldos);
				this.$emit("saved", createdBookYear);
				this.$router.push("/");
			}catch(err){
				this.step = 1;
			}
		},
	},
	components: {
		AppSettingsFriendlyIds,
	},
	i18nEx: {
		componentPrefix: "components.bookyear"
	}
});
